module.exports = __webpack_public_path__ + "common/sidebar/img-card-list-89ced6f4cf2a11842dbf2b59a1f3baf7.png";